import { UI, HStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';
import { FlatList } from 'react-native';

import { LoadingTable } from '../LoadingTable';

import { desktopMaxHeight, tableHead, desktopWidthCols } from './constants';

import { CustomerTiesContainerDataProps } from '.';

export const ProductItemDesktopWrapper: React.FC = () => (
  <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />
);

interface ProductItemProps {
  item: CustomerTiesContainerDataProps['data'][0];
}

export const ProductItemDesktop: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <HStack alignItems="center" my={Spacing['stack.xxxs']}>
      <UI.TableItem testId={'table-product-accessor'} width={desktopWidthCols.product}>
        <UI.Text>{item.nomeProduto}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-product-d1Value'} width={desktopWidthCols.date}>
        <UI.Text>{Utils.Mask.DateFormat(item.dataAdesao, 'dd/MM/yyyy - HH:mm:ss')}</UI.Text>
      </UI.TableItem>
      <UI.TableItem testId={'table-product-d2Value'} width={desktopWidthCols.status}>
        <UI.Text>{item.status}</UI.Text>
      </UI.TableItem>
    </HStack>
  );
};

export const ContentDesktop: React.FC<CustomerTiesContainerDataProps> = ({ isLoading, data }) => {
  return (
    <UI.Shadow
      my={Spacing['inset.sm']}
      level={1}
      borderRadius={BoxBorder.heavy}
      paddingX={Spacing['inline.xxxs']}
      paddingY={Spacing['inline.xxs']}
      pb={0}>
      <UI.Table testId="table-customers-ties" isLoading={false} cols={3} rows={5}>
        <UI.TableHead testId="table-customers-ties-head" pl={Spacing['inset.xs']}>
          {Object.entries(tableHead).map((tableHeadItem, index) => {
            const width = Object.entries(desktopWidthCols).map((col) => col[1])[index];

            return (
              <UI.TableTitle
                key={tableHeadItem[0]}
                testId={`table-customers-ties-title-${index}`}
                width={width}>
                {tableHeadItem[1] as string}
              </UI.TableTitle>
            );
          })}
        </UI.TableHead>

        {isLoading ? (
          <LoadingTable columns={3} />
        ) : (
          <FlatList
            windowSize={20}
            maxToRenderPerBatch={20}
            updateCellsBatchingPeriod={5}
            data={data}
            ItemSeparatorComponent={ProductItemDesktopWrapper}
            contentContainerStyle={{ maxHeight: desktopMaxHeight }}
            // ListEmptyComponent={<LoadingTable columns={columns} />}
            showsVerticalScrollIndicator={false}
            // onEndReached={handleEndReached}
            onEndReachedThreshold={1.5}
            // ListFooterComponent={loadingFooter}
            renderItem={({ item }) => <ProductItemDesktop item={item} />}
          />
        )}
      </UI.Table>
    </UI.Shadow>
  );
};
